import { setIsLogin } from "../../slicers/User Info Slicer";
import { faro } from "@grafana/faro-web-sdk";
import { getCookie } from "../../../additional/functions";
import { usePostRefreshMutation } from "../auth api";

const handleUnauthorized = async (api) => {
  const refreshToken = getCookie("csrf_refresh_token");
  const accessToken = getCookie("csrf_access_token");
  const [refresh] = usePostRefreshMutation();

  if (!refreshToken && !accessToken) {
    api.dispatch(setIsLogin(false));
    faro.api.resetUser();
  } else if (!!refreshToken && !accessToken) {
    try {
      await refresh().unwrap();
    } catch (error) {
      console.error(error);
    }
  }
};

const handleError = (error, api) => {
  console.error(error);
};

export const BaseQueryErrorHandler = (baseQuery) => {
  return async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);

    if (result?.error) {
      const status = result.error.status;

      switch (status) {
        case 401: {
          handleUnauthorized(api);
          break;
        }
        default: {
          handleError(result.error, api);
          break;
        }
      }
    }

    return result;
  };
};
